import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useMsal, useAccount } from "@azure/msal-react";
import { silentRequest } from "../../../authConfig";

import { useHistory, useLocation } from 'react-router-dom';



import {
  Stack,
  Icon,
  PrimaryButton,
  DefaultButton,
  Spinner,
  getTheme,
  MessageBar,
  MessageBarType,
  Dropdown,
  Separator,
  mergeStyleSets,
  DatePicker,
  DayOfWeek,
  TextField
} from '@fluentui/react';

import styled from 'styled-components';

import moment from 'moment-timezone';

// const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;

const theme = getTheme();

//Dropzone Style

const getColor = (props) => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isDragActive) {
    return '#2196f3';
  }
  //return '#eeeeee';
  //return 'rgb(194, 194, 194)';
  return 'rgb(134, 134, 134)';
}

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: ${props => getColor(props)};
    border-style: dashed;    
    background-color: #ffffff;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
    margin-top: 5px;
`;

// Processing dialog style
const spinnerStyles = {
  circle: {
    height: 24,
    width: 24,
    borderWidth: 4,
    marginTop: 25
  }
}

const spinnerStylesLoading = {
  circle: {
    height: 56,
    width: 56,
    borderWidth: 4,
  },
};

const cardStyle = {
  paddingLeft: 30,
  paddingRight: 30,
  paddingTop: 20,
  paddingBottom: 30,
  background: '#ffffff',
  marginLeft: '0',
  marginTop: '10px',
  boxShadow: theme.effects.elevation4,
};

const homeStyles = {
  border: 0,
  margin: 0,
  width: '100%',
  background: '#FAF9F8',
  position: 'relative',
};

const dropdownStyles = {
  dropdown: { width: 250 },
};

const controlClass = mergeStyleSets({
  control: {
    margin: '0 0 15px 0',
    maxWidth: '300px',
  },
  hover: {
    selectors: {
      '&:hover': { background: theme.palette.neutralLight },
    },
  },
});

const toThaiDateString = (isoDateTime) => {
  let date = "";
  date = new Date(isoDateTime);

  //console.log(dateTime.toLocaleDateString() + ' ' + dateTime.toLocaleTimeString());
  /* 
let monthNames = [
  "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
  "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม",
  "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
];
*/
  let year = date.getFullYear() + 543;
  //let month = monthNames[date.getMonth()];
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let numOfDay = date.getDate().toString().padStart(2, "0");

  let hour = date.getHours().toString().padStart(2, "0");
  let minutes = date.getMinutes().toString().padStart(2, "0");
  let second = date.getSeconds().toString().padStart(2, "0");

  return `${numOfDay}/${month}/${year} ${hour}:${minutes}:${second} น.`;
};

const onFormatDate = (date, format) => {
  if (format === 'CE') {
    return `${date.getDate()}`.padStart(2, '0') + '/' + `${date.getMonth() + 1}`.padStart(2, '0') + '/' + date.getFullYear();
  } else {
    return `${date.getDate()}`.padStart(2, '0') + '/' + `${date.getMonth() + 1}`.padStart(2, '0') + '/' + (date.getFullYear() + 543);
  }
};

const SettingsCompaniesDetails = () => {

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const history = useHistory();
  const location = useLocation();

  const [data] = useState(location.state);

  const [oid, setOid] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [companiesDetails, setCompaniesDetails] = useState({});

  const billingsTypeList = [
    { key: 'prepaid', text: 'Prepaid' },
    { key: 'subscription', text: 'Subscription' },
    { key: 'trial', text: 'Trial' },
    { key: 'expired', text: 'Expired' },
  ];

  const enabledList = [
    { key: 'true', text: 'เปิดใช้งาน' },
    { key: 'false', text: 'ปิดใช้งาน' },
    { key: '-', text: '-' },
  ];

  const digitalSignList = [
    { key: 'true', text: 'เอกสาร e-Tax Invoice & e-Receipt' },
    { key: 'false', text: 'เอกสารกระดาษ' },
  ];

  const attachXmlList = [
    { key: 'true', text: 'แนบไฟล์ XML' },
    { key: 'false', text: 'ไม่แนบไฟล์ XML' },
  ];

  const ltvList = [
    { key: 'true', text: 'LTV Enabled' },
    { key: 'false', text: 'LTV Disabled' },
    { key: '-', text: '-' },
  ];

  const digitallySignedByList = [
    { key: 'true', text: 'แสดงข้อความ Digitally signed by' },
    { key: 'false', text: 'ไม่แสดงข้อความ Digitally signed by' },
  ];

  const digitallySignedByBEList = [
    { key: 'true', text: 'แสดงปี พ.ศ. บน Digitally signed by' },
    { key: 'false', text: 'แสดงปี ค.ศ. บน Digitally signed by' },
  ];

  const pdfaList = [
    { key: 'true', text: 'ไฟล์ PDF-A3' },
    { key: 'false', text: 'ไฟล์ PDF ธรรมดา' },
  ];

  const enableSmsList = [
    { key: 'true', text: 'เปิดการส่ง SMS' },
    { key: 'false', text: 'ปิดการส่ง SMS' },
  ];

  const serviceProviderList = [
    { key: 'null', text: 'ปิดการนำส่งผ่าน Service Provider' },
    { key: 'ginkgo-soft', text: 'Ginkgo Soft' },
    { key: 'stream-it-consulting', text: 'Stream IT Consulting' },
  ];

  const [packages, setPackages] = useState([])
  const [currentAddOnPackages, setCurrentAddOnPackages] = useState([])
  const [packagesAddOns, setPackagesAddOns] = useState([])
  const [monthsRemaining, setMonthsRemaining] = useState(0);

  const DayPickerStrings = {
    months: [
      'มกราคม',
      'กุมภาพันธ์',
      'มีนาคม',
      'เมษายน',
      'พฤษภาคม',
      'มิถุนายน',
      'กรกฎาคม',
      'สิงหาคม',
      'กันยายน',
      'ตุลาคม',
      'พฤศจิกายน',
      'ธันวาคม',
    ],
    shortMonths: [
      'ม.ค.',
      'ก.พ.',
      'มี.ค.',
      'เม.ย.',
      'พ.ค.',
      'มิ.ย.',
      'ก.ค.',
      'ส.ค.',
      'ก.ย.',
      'ต.ค.',
      'พ.ย.',
      'ธ.ค.',
    ],
    days: [
      'อาทิตย์', 
      'จันทร์', 
      'อังคาร', 
      'พุธ', 
      'พฤหัสบดี', 
      'ศุกร์', 
      'เสาร์', 
    ],
    shortDays: [
      'อา.', 
      'จ.', 
      'อ.', 
      'พ.', 
      'พฤ.', 
      'ศ.', 
      'ส.'
    ],
    goToToday: 'ไปวันที่ปัจจุบัน',
    prevMonthAriaLabel: 'ไปเดือนที่แล้ว',
    nextMonthAriaLabel: 'ไปเดือนถัดไป',
    prevYearAriaLabel: 'ไปปีที่แล้ว',
    nextYearAriaLabel: 'ไปปีถัดไป',
    closeButtonAriaLabel: 'ปิด',
    monthPickerHeaderAriaLabel: '{0}, เลือกเพื่อเปลี่ยนเดือน',
    yearPickerHeaderAriaLabel: '{0}, เลือกเพื่อเปลี่ยนปี',
    invalidInputErrorMessage: 'รูปแบบวันที่ไม่ถูกต้อง'
  };

  const [firstDayOfWeek] = useState(DayOfWeek.Sunday);

  const [getNewData, setGetNewData] = useState(false);
  const [billingsType, setBillingType] = useState('');
  const [enabled, setEnabled] = useState('-');
  const [accountData, setAccountData] = useState({});
  const [digitalSign, setDigitalSign] = useState('true');
  const [pdfa, setPdfa] = useState('true');
  const [attachXml, setAttachXml] = useState('false');
  const [ltv, setLtv] = useState('false');
  const [digitallySignedBy, setDigitallySignedBy] = useState('true');
  const [digitallySignedByBE, setDigitallySignedByBE] = useState('true');
  const [enableSms, setEnableSms] = useState('false');
  const [serviceProvider, setServiceProvider] = useState(null);

  const [ginkgoRequiredError, setGinkgoRequiredError] = useState(false);
  const [ginkgoApiKey, setGinkgoApiKey] = useState('');
  const [ginkgoShowPassword, setGinkgoShowPassword] = useState(false);

  // const [credits, setCredits] = useState(0);
  // const [topupAmount, setTopupAmount] = useState(0);
  // const [totalAmount, setTotalAmount] = useState(0);
  // const [lastTopup, setLastTopup] = useState(0);
  // const [lastTopupTime, setLastTopupTime] = useState('');

  // const [isLoading, setIsLoading] = useState(true);
  const [isLoadingGetNewData, setIsLoadingGetNewData] = useState(true);
  const [isLoadingSubmitBillingType, setIsLoadingSubmitBillingType] = useState(false);
  const [isLoadingSubmitBillingSubscription, setIsLoadingSubmitBillingSubscription] = useState(false);
  const [isLoadingSubmitEnabled, setIsLoadingSubmitEnabled] = useState(false);
  const [isLoadingSubmitDigitalSign, setIsLoadingSubmitDigitalSign] = useState(false);
  const [isLoadingSubmitPdfa, setIsLoadingSubmitPdfa] = useState(false);
  const [isLoadingSubmitAttachXml, setIsLoadingSubmitAttachXml] = useState(false);
  const [isLoadingSubmitLtv, setIsLoadingSubmitLtv] = useState(false);
  const [isLoadingDigitallySignedBy, setIsLoadingDigitallySignedBy] = useState(false);
  const [isLoadingDigitallySignedByBE, setIsLoadingDigitallySignedByBE] = useState(false);
  const [isLoadingSubmitEnableSms, setIsLoadingSubmitEnableSms] = useState(false);
  const [isLoadingSubmitServiceProvider, setIsLoadingSubmitServiceProvider] = useState(false);
  const [isLoadingSubmitPackage, setIsLoadingSubmitPackage] = useState(false);
  const [isLoadingSubmitNextPackage, setIsLoadingSubmitNextPackage] = useState(false);
  const [isLoadingSubmitPackageTo, setIsLoadingSubmitPackageTo] = useState(false);
  const [isLoadingSubmitPackageStatus, setIsLoadingSubmitPackageStatus] = useState(false)
  const [isLoadingSubmitMonthsRemainings, setIsLoadingSubmitMonthsRemainings] = useState(false);
  const [isLoadingSubmitBillingManual, setIsLoadingSubmitBillingManual] = useState(false)
  const [isLoadingSubmitAutoCreateReceipt, setIsLoadingSubmitAutoCreateReceipt] = useState(false)
  const [isLoadingSubmitPercentWht, setIsLoadingSubmitPercentWht] = useState(false)

  const [isLoadingSubmitPackageAddOn, setIsLoadingSubmitPackageAddOn] = useState(false)

  const [selectedBillingSubscription, setSelectedBillingSubscription] = useState('true')
  const [selectedBillingManual, setSelectedBillingManual] = useState('false')
  const [selectedAutoCreateReceipt, setSelectedAutoCreateReceipt] = useState('-')
  const [selectedMainPackage, setSelectedMainPackage] = useState('')
  const [selectedPackageStatus, setSelectedPackageStatus] = useState('-')
  const [currentMainPackage, setCurrentMainPackage] = useState(null)
  const [packageFrom, setPackageFrom] = useState(null)

  const [selectedAddOnPackage, setSelectedAddOnPackage] = useState('')
  const [packageAddOnFrom, setPackageAddOnFrom] = useState(null)

  const [packageTo, setPackageTo] = useState(null)
  const [nextPackage, setNextPackage] = useState('')
  const [nextPackageFrom, setNextPackageFrom] = useState(null)

  const [selectPercentWht, setSelectPercentWht] = useState(0);

  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (companyId) {
      getPackage()
      getPackageAll()
      getCurrentPackageAddOn()
      getPackageAddOnAll()
    }
  }, [companyId]);

  useEffect(() => {
    if (serviceProvider === "ginkgo-soft" && companyId) {
      getGinkgoKeyVaultSecret(companyId);
    }
  }, [companyId, serviceProvider]);
  
  useEffect(() => {

    console.log('useEffect accountData call!: ');

    console.log('accountData', accountData);

  }, [accountData]);

  useEffect(() => {
    console.log('useEffect getNewData call!');

    console.log('oid: ', oid);
    console.log('companyId: ', companyId);

    if (getNewData) {

      if (oid && companyId) {
        //console.log('useEffect data call! not undefied.');

        console.log('data: ', data);

        accountsOidList(oid);
        companiesDetailsCreatedByList(oid);

      }

      // setGetNewData(false);
      // setIsLoadingGetNewData(false);

    }

  }, [getNewData]);

  useEffect(() => {
    console.log('useEffect data call!: ', data);


    if (data !== undefined) {
      //console.log('useEffect data call! not undefied.');

      console.log('data: ', data);
      setCompanyId(data.companyId);
      setOid(data.oid)

      accountsOidList(data.oid);
      companiesDetailsCreatedByList(data.oid);

      // setGetNewData(true);
      // setIsLoadingGetNewData(true);

    } else {
      history.push({ pathname: '/accounts/prepaid', state: {} });
    }


  }, [data]);

  async function companiesDetailsCreatedByList(oid) {

    // console.log('useEffect call!');

    // let companiesDetailsCreatedByListEndpoint = 'http://localhost:7071/api/CompaniesDetailsCreatedByList?createdByList=' + oid;
    let companiesDetailsCreatedByListEndpoint = ADMIN_API_URL + '/companies-details?createdByList=' + oid;
    console.log("companiesDetailsCreatedByListEndpoint: ", companiesDetailsCreatedByListEndpoint);

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        // Do something with the tokenResponse
        console.log("Token response: ", tokenResponse);

        // Retrive companies details list
        const [responseCompaniesDetailsCreatedByList] = await Promise.all([
          axios
            .get(companiesDetailsCreatedByListEndpoint, {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .catch((error) => console.log(error)),
        ]);
        console.log("responseCompaniesDetailsCreatedByList: ", responseCompaniesDetailsCreatedByList.data);


        if (responseCompaniesDetailsCreatedByList.data.length > 0) {

          let _companiesDetails = responseCompaniesDetailsCreatedByList.data[0];

          setCompaniesDetails(_companiesDetails);

          if (_companiesDetails?.enabled === true) {
            setEnabled('true');
          } else if (_companiesDetails?.enabled === false) {
            setEnabled('false');
          } else {
            setEnabled('-');
          }

          setBillingType(_companiesDetails?.billings?.type);

          if (_companiesDetails?.settings?.digitalSign === true) {
            setDigitalSign('true');
          } else {
            setDigitalSign('false');
          }

          if (_companiesDetails?.settings?.etax?.pdfa === true) {
            setPdfa('true');
          } else {
            setPdfa('false');
          }

          if (_companiesDetails?.settings?.etax?.attachXml === true) {
            setAttachXml('true');
          } else {
            setAttachXml('false');
          }

          if (_companiesDetails?.settings?.ltv === true) {
            setLtv('true');
          } else if (_companiesDetails?.settings?.ltv === false) {
            setLtv('false');
          } else {
            setLtv('-');
          }

          if (_companiesDetails?.settings?.signature?.visible === true) {
            setDigitallySignedBy('true');
          } else {
            setDigitallySignedBy('false');
          }

          if (_companiesDetails?.settings?.signature?.dateBE === true) {
            setDigitallySignedByBE('true');
          } else {
            setDigitallySignedByBE('false');
          }

          if (_companiesDetails?.settings?.enableSms === true) {
            setEnableSms('true');
          } else {
            setEnableSms('false');
          }

          // console.log("_companiesDetails?.settings?.etax?.serviceProvider?.id:", _companiesDetails?.settings?.etax?.serviceProvider?.id);

          if (_companiesDetails?.settings?.etax?.serviceProvider?.id === 'ginkgo-soft') {
            setServiceProvider('ginkgo-soft');
          } else if (_companiesDetails?.settings?.etax?.serviceProvider?.id === 'stream-it-consulting') {
            setServiceProvider('stream-it-consulting');
          } else {
            setServiceProvider('null');
          }

          if (_companiesDetails?.billings?.subscription) {
            setSelectedBillingSubscription('true');
          } else if (_companiesDetails?.billings?.subscription === false) {
            setSelectedBillingSubscription('false');
          } else {
            setSelectedBillingSubscription('-');
          }

          if (_companiesDetails?.billings?.manual) {
            setSelectedBillingManual('true');
          } else if (_companiesDetails?.billings?.manual === false) {
            setSelectedBillingManual('false');
          } else {
            setSelectedBillingManual('-');
          }

          if (_companiesDetails?.billings?.autoCreateReceiptTaxInvoice) {
            setSelectedAutoCreateReceipt('true');
          } else if (_companiesDetails?.billings?.autoCreateReceiptTaxInvoice === false) {
            setSelectedAutoCreateReceipt('false');
          } else {
            setSelectedAutoCreateReceipt('-');
          }

          if (_companiesDetails?.billings?.wht?.percentWht) {
            setSelectPercentWht(_companiesDetails?.billings?.wht?.percentWht);
          }

          // setIsLoading(false);
          setGetNewData(false);
          setIsLoadingGetNewData(false);

        }

      })
      .catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);
      });

    

  }

  async function accountsOidList(oid) {

    console.log('useEffect call!');

    // let accountsOidListEndpoint = 'http://localhost:7071/api/AccountsOidList?oidList=' + oid;
    let accountsOidListEndpoint = ADMIN_API_URL + '/accounts?oidList=' + oid;
    console.log("accountsOidListEndpoint: ", accountsOidListEndpoint);

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        // Do something with the tokenResponse
        console.log("Token response: ", tokenResponse);

        // Retrive companies details list
        const [responseAccountsOidList] = await Promise.all([
          axios
            .get(accountsOidListEndpoint, {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .catch((error) => console.log(error)),
        ]);
        console.log("responseAccountsOidList: ", responseAccountsOidList.data);


        if (responseAccountsOidList.data.length > 0) {
          setAccountData(responseAccountsOidList.data[0]);
        }

      })
      .catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);
      });

  }

  async function getGinkgoKeyVaultSecret(cid) {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responseKeyValutSecret = await axios.get(`${ADMIN_API_URL}/functions/key-vault-secrets`, {
                                                      headers: {
                                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                        'secretName': `sp-ginkgo-soft-api-key-${cid}`,
                                                        // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                                                      },
                                                    });

      console.log("responseKeyValutSecret", responseKeyValutSecret);
      const _apiKey = responseKeyValutSecret.data.value || '';
      setGinkgoApiKey(_apiKey);
    
    }).catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log("getGinkoKeyVaultSecret error", error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function getPackage() {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responseCurrentPackage = await axios.get(`${ADMIN_API_URL}/packages/main?companyId=${companyId}`, {
      // const responseCurrentPackage = await axios.get(`http://localhost:7071/api/packages/main/${'c8d1bf6b-bf74-4608-ae46-34a282990e13'}`, {
                                                      headers: {
                                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                        'cid': companyId,
                                                        // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                                                      },
                                                    })


      console.log("responseCurrentPackage", responseCurrentPackage);

      if (responseCurrentPackage?.data) {
        setCurrentMainPackage(responseCurrentPackage.data);
        setSelectedPackageStatus(responseCurrentPackage.data.status || '-');
        setSelectedMainPackage(responseCurrentPackage.data.packageId || '');
        setMonthsRemaining(responseCurrentPackage.data.monthsRemaining);

        setNextPackage(responseCurrentPackage.data.nextPeriod?.packageId || '');
      }


    
    }).catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log("getPackageAndAccountDetail error", error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function getPackageAll() {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responsePackages = await axios.get(`${ADMIN_API_URL}/packages?packageType=main&type=document`, {
      // const responsePackages = await axios.get(`http://localhost:7071/api/packages/main`, {
                                                      headers: {
                                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                        'cid': companyId,
                                                        // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                                                      },
                                                    })


      console.log("response getPackageAll", responsePackages);

      const sortPackage = responsePackages.data.packages.sort((a, b) => {
        if (a.packageId === "paper-main-1-months-5-documents-trial") return 1;
        if (b.packageId === "paper-main-1-months-5-documents-trial") return -1;
        
        if (a.packageId === "etax-main-1-months-5-documents-trial") return 1;
        if (b.packageId === "etax-main-1-months-5-documents-trial") return -1;

        if (a.etax !== b.etax) {
          return a.etax ? -1 : 1;
        }

        if (a.monthsLimit !== b.monthsLimit) {
          return a.monthsLimit === 1 ? -1 : 1;
        }

        return a.total - b.total;
      });

      console.log("sortPackage", sortPackage);

      const _packages = sortPackage.map(_package => ({
        key: _package.packageId,
        text: _package.descriptionTH.replace('ค่า Subscription ซอฟต์แวร์ Leceipt ', '').replace('(ต้นฉบับเอกสารเป็นกระดาษ)', '(กระดาษ)')
      }));

      _packages.push({
        key: "paper-main-6-months-100-documents-otod",
        text: "OTOD AI ช่วยชาติ 100 เอกสาร 6 เดือน",
        packageId: "paper-main-6-months-100-documents-otod",
        total: 100,
        name: "ค่า Subscription ซอฟต์แวร์ Leceipt 6 เดือน (100 เอกสาร/เดือน)",
        descriptionTH: "ค่า Subscription ซอฟต์แวร์ Leceipt 6 เดือน (100 เอกสาร/เดือน)",
        descriptionEN: "6-Months Subscription for Leceipt Software (100 documents/month)",
        monthsLimit: 6,
        name: "ค่า Subscription ซอฟต์แวร์ Leceipt 6 เดือน (100 เอกสาร/เดือน)",
        promotions: {
          discount: {
            percent: 0,
            value: 0
          },
          additional: {
            total: 0
          },
          monthsLimit: 0
        },
        price: 5000,
        type: "document",
        additionalPrice: 10,
        etax: false
      });

      setPackages(_packages);

    
    }).catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log("getPackageAndAccountDetail error", error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function getCurrentPackageAddOn() {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responsePackages = await axios.get(`${ADMIN_API_URL}/packages/add-ons?status=active`, {
      // const responsePackages = await axios.get(`http://localhost:7071/api/packages/add-ons?status=active`, {
                                                      headers: {
                                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                        'cid': companyId,
                                                        // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                                                      },
                                                    })


      console.log("responseCurrentPackagesAddOn", responsePackages);

      const isoTimeNow = new Date().toISOString();

      const _packages = responsePackages.data.packages.filter(_package => _package.to >= isoTimeNow);
      setCurrentAddOnPackages(_packages);

    
    }).catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log("getPackageAndAccountDetail error", error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function getPackageAddOnAll() {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responsePackages = await axios.get(`${ADMIN_API_URL}/packages?packageType=addOn`, {
                                                      headers: {
                                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                        'cid': companyId,
                                                        // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                                                      },
                                                    })


      console.log("responsePackagesAddOn", responsePackages);

      const _packages = responsePackages.data.packages.map(_package => ({
        key: _package.packageId,
        text: _package.name
      }));
      setPackagesAddOns(_packages);

    
    }).catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log("getPackageAndAccountDetail error", error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  const handleSubmitServiceProvider = (e) => {

    e.preventDefault();

    setGinkgoRequiredError(false);

    if (serviceProvider === "ginkgo-soft") {
      if (!ginkgoApiKey) {
        setGinkgoRequiredError(true);
  
        return;
      }
    }

    setIsLoadingSubmitServiceProvider(true);
    // setIsLoadingGetNewData(true);

    let _serviceProvider = "null";
    
    if (serviceProvider === "ginkgo-soft") {
      _serviceProvider = "ginkgo-soft";
    } else if (serviceProvider === "stream-it-consulting") {
      _serviceProvider = "stream-it-consulting";
    }

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            ADMIN_API_URL + '/companies-details/' + companyId,
            {
              replace: '/settings/etax/serviceProvider/id',
              value: _serviceProvider
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);

              if (serviceProvider === "ginkgo-soft") {
                instance
                  .acquireTokenSilent({ ...silentRequest, account: account })
                  .then((tokenResponse) => {
                    axios
                      .post(
                        ADMIN_API_URL + '/functions/key-vault-secrets',
                        {
                          secretName: `sp-ginkgo-soft-api-key-${companyId}`,
                          secretValue: ginkgoApiKey
                        },
                        {
                          headers: {
                            Authorization: 'Bearer ' + tokenResponse.accessToken,
                            'Content-Type': 'application/json',
                          },
                        }
                      )
                      .then(
                        (response) => {
                          //console.log(response.data.id);
                          console.log(response);
                          setIsLoadingSubmitServiceProvider(false);
                          // setIsLoadingGetNewData(false);
            
                          getGinkgoKeyVaultSecret(companyId);
            
                          setShowSuccess(true);
                          window.scrollTo(0, 0);
            
                        },
                        (error) => {
                          console.log(error);
                          setIsLoadingSubmitServiceProvider(false);
                          // setIsLoadingGetNewData(false);
            
                          getGinkgoKeyVaultSecret(companyId);
            
                          setShowError(true);
                          window.scrollTo(0, 0);
                        }
                      );
            
                  })
                  .catch((error) => {
            
                    //Acquire token silent failure, and send an interactive request
                    console.log(error);
                    instance.acquireTokenRedirect(silentRequest);
            
                  });
              } else {
                setIsLoadingSubmitServiceProvider(false);
                // setIsLoadingGetNewData(false);

                setGetNewData(true);

                setShowSuccess(true);
                window.scrollTo(0, 0);
              }

            },
            (error) => {
              console.log(error);
              setIsLoadingSubmitServiceProvider(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              window.scrollTo(0, 0);
            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

    
  }

  const handleSubmitEnableSms = (e) => {

    e.preventDefault();

    setIsLoadingSubmitEnableSms(true);
    setIsLoadingGetNewData(true);

    let _enableSms = (enableSms === 'true');

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            ADMIN_API_URL + '/companies-details/' + companyId,
            {
              replace: '/settings/enableSms',
              value: _enableSms
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitEnableSms(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {
              console.log(error);
              setIsLoadingSubmitEnableSms(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);
            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

  }

  const handleDigitallySignedByBE = (e) => {

    e.preventDefault();

    setIsLoadingDigitallySignedByBE(true);
    setIsLoadingGetNewData(true);

    let _digitallySignedByBE = (digitallySignedByBE === 'true');

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            ADMIN_API_URL + '/companies-details/' + companyId,
            {
              replace: '/settings/signature/dateBE',
              value: _digitallySignedByBE
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingDigitallySignedByBE(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {
              console.log(error);
              setIsLoadingDigitallySignedByBE(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);
            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

  }

  const handleDigitallySignedBy = (e) => {

    e.preventDefault();

    setIsLoadingDigitallySignedBy(true);
    setIsLoadingGetNewData(true);

    let _digitallySignedBy = (digitallySignedBy === 'true');

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            ADMIN_API_URL + '/companies-details/' + companyId,
            {
              replace: '/settings/signature/visible',
              value: _digitallySignedBy
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingDigitallySignedBy(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {
              console.log(error);
              setIsLoadingDigitallySignedBy(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);
            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

  }

  const handleSubmitLtv = (e) => {

    e.preventDefault();

    setIsLoadingSubmitLtv(true);
    setIsLoadingGetNewData(true);

    let _ltv = (ltv === 'true');

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            ADMIN_API_URL + '/companies-details/' + companyId,
            {
              replace: '/settings/ltv',
              value: _ltv
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitLtv(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {
              console.log(error);
              setIsLoadingSubmitLtv(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);
            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

  }

  const handleSubmitAttachXml = (e) => {

    e.preventDefault();

    setIsLoadingSubmitAttachXml(true);
    setIsLoadingGetNewData(true);

    let _attachXml = (attachXml === 'true');

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            ADMIN_API_URL + '/companies-details/' + companyId,
            {
              replace: '/settings/etax/attachXml',
              value: _attachXml
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitAttachXml(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {
              console.log(error);
              setIsLoadingSubmitAttachXml(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);
            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

  }

  const handleSubmitPdfa = (e) => {

    e.preventDefault();

    setIsLoadingSubmitPdfa(true);
    setIsLoadingGetNewData(true);

    let _pdfa = (pdfa === 'true');

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            ADMIN_API_URL + '/companies-details/' + companyId,
            {
              replace: '/settings/etax/pdfa',
              value: _pdfa
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitPdfa(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {
              console.log(error);
              setIsLoadingSubmitPdfa(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);
            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

  }

  const handleSubmitDigitalSign = (e) => {

    e.preventDefault();

    setIsLoadingSubmitDigitalSign(true);
    setIsLoadingGetNewData(true);

    let _digitalSign = (digitalSign === 'true');

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            ADMIN_API_URL + '/companies-details/' + companyId,
            {
              replace: '/settings/digitalSign',
              value: _digitalSign
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitDigitalSign(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {
              console.log(error);
              setIsLoadingSubmitDigitalSign(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);
            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

  }

  

  const handleSubmitฺBillingType = (e) => {

    e.preventDefault();

    setIsLoadingSubmitBillingType(true);
    setIsLoadingGetNewData(true);


    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            ADMIN_API_URL + '/companies-details/' + companyId,
            {
              replace: '/billings/type',
              value: billingsType
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitBillingType(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {

              console.log(error);
              setIsLoadingSubmitBillingType(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);

            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

  }

  const handleSubmitBillingSubscription = (e) => {
    e.preventDefault();

    setIsLoadingSubmitBillingSubscription(true);
    setIsLoadingGetNewData(true);

    let _billings = companiesDetails.billings;

    if (selectedBillingSubscription === 'true') {
      _billings.subscription = true;
    } else {
      _billings.subscription = false;
    }

    console.log("_billings", _billings);

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            `${ADMIN_API_URL}/companies-details/` + companyId,
            // `http://localhost:7071/api/companies-details`,
            {
              replace: '/billings',
              value: _billings
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
                'cid': companyId,
                // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitBillingSubscription(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {

              console.log(error);
              setIsLoadingSubmitBillingSubscription(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);

            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });
    
  }

  const handleSubmitPercentWht = (e) => {
    e.preventDefault();

    setIsLoadingSubmitBillingManual(true);
    setIsLoadingGetNewData(true);

    let _billings = companiesDetails.billings;

    if (_billings?.wht) {
      _billings.wht.percentWht = selectPercentWht;
    } else {
      _billings = {...companiesDetails.billings, wht: { percentWht: selectPercentWht}}
    }

    console.log("_billings", _billings);

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            `${ADMIN_API_URL}/companies-details/` + companyId,
            // `http://localhost:7071/api/companies-details`,
            {
              replace: '/billings',
              value: _billings
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
                'cid': companyId,
                // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitBillingManual(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {

              console.log(error);
              setIsLoadingSubmitBillingManual(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);

            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });
    
  }

  const handleSubmitBillingManual = (e) => {
    e.preventDefault();

    setIsLoadingSubmitBillingManual(true);
    setIsLoadingGetNewData(true);

    let _billings = companiesDetails.billings;

    if (selectedBillingManual === 'true') {
      _billings.manual = true;
    } else {
      _billings.manual = false;
    }

    console.log("_billings", _billings);

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            `${ADMIN_API_URL}/companies-details/` + companyId,
            // `http://localhost:7071/api/companies-details`,
            {
              replace: '/billings',
              value: _billings
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
                'cid': companyId,
                // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitBillingManual(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {

              console.log(error);
              setIsLoadingSubmitBillingManual(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);

            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });
    
  }

  const handleSubmitAutoCreateReceipt = (e) => {
    e.preventDefault();

    setIsLoadingSubmitAutoCreateReceipt(true);
    setIsLoadingGetNewData(true);

    let _billings = { ...companiesDetails.billings };

    if (selectedAutoCreateReceipt === 'true') {
      _billings.autoCreateReceiptTaxInvoice = true;
    } else {
      _billings.autoCreateReceiptTaxInvoice = false;
    }

    console.log("_billings", _billings);

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            `${ADMIN_API_URL}/companies-details/` + companyId,
            {
              replace: '/billings',
              value: _billings
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
                'cid': companyId,
              },
            }
          )
          .then(
            (response) => {
              console.log(response);
              setIsLoadingSubmitAutoCreateReceipt(false);

              setGetNewData(true);

              setShowSuccess(true);

            },
            (error) => {

              console.log(error);
              setIsLoadingSubmitAutoCreateReceipt(false);

              setGetNewData(true);

              setShowError(true);

            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

  }

  const handleSubmitPackageStatus = (e) => {

    e.preventDefault();

    if (selectedPackageStatus) {
      setIsLoadingSubmitPackageStatus(true);
      setIsLoadingGetNewData(true);
  
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          axios
            .patch(
              `${ADMIN_API_URL}/packages/main`,
              // `http://localhost:7071/api/packages/main`,
              {
                replace: '/status',
                value: selectedPackageStatus
              },
              {
                headers: {
                  Authorization: 'Bearer ' + tokenResponse.accessToken,
                  'Content-Type': 'application/json',
                  'cid': companyId,
                  // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                },
              }
            )
            .then(
              (response) => {
                //console.log(response.data.id);
                console.log(response);
                setIsLoadingSubmitPackageStatus(false);
                // setIsLoadingGetNewData(false);

                getPackage()
  
                setGetNewData(true);
  
                setShowSuccess(true);
                // window.scrollTo(0, 0);
  
              },
              (error) => {
  
                console.log(error);
                setIsLoadingSubmitBillingType(false);
                // setIsLoadingGetNewData(false);
  
                setGetNewData(true);
  
                setShowError(true);
                // window.scrollTo(0, 0);
  
              }
            );
  
        })
        .catch((error) => {
  
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
  
        });
    }
  }

  const handleSubmitPackageMonthsRemainings = (e) => {

    e.preventDefault();

    setIsLoadingSubmitMonthsRemainings(true);
    setIsLoadingGetNewData(true);

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            `${ADMIN_API_URL}/packages/main`,
            // `http://localhost:7071/api/packages/main`,
            {
              replace: '/monthsRemaining',
              value: Number(monthsRemaining)
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
                'cid': companyId,
                // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitMonthsRemainings(false);
              // setIsLoadingGetNewData(false);

              getPackage()

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {

              console.log(error);
              setIsLoadingSubmitBillingType(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);

            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });
    
  }

  const handleSubmitPackage = (e) => {

    e.preventDefault();

    if (selectedMainPackage && packageFrom) {
      setIsLoadingSubmitPackage(true);
      setIsLoadingGetNewData(true);

      const _selectdPackageDetails = packages.find(_package => _package.key === selectedMainPackage);
  
      console.log("_selectdPackageDetails", _selectdPackageDetails);
      if (_selectdPackageDetails.packageId) {
        instance
          .acquireTokenSilent({ ...silentRequest, account: account })
          .then((tokenResponse) => {
            axios
              .post(
                `${ADMIN_API_URL}/packages/main/custom`,
                // `http://localhost:7071/api/packages/main/custom`,
                {
                  packageId: selectedMainPackage,
                  from: moment(packageFrom).tz("Asia/Bangkok").startOf('day').toISOString(),
                  total: _selectdPackageDetails.total,
                  name: _selectdPackageDetails.name,
                  descriptionTH: _selectdPackageDetails.descriptionTH,
                  descriptionEN: _selectdPackageDetails.descriptionEN,
                  monthsLimit: _selectdPackageDetails.monthsLimit,
                  promotions: _selectdPackageDetails.promotions,
                  price: _selectdPackageDetails.price,
                  type: _selectdPackageDetails.type,
                  additionalPrice: _selectdPackageDetails.additionalPrice,
                  etax: _selectdPackageDetails.etax,
                },
                {
                  headers: {
                    Authorization: 'Bearer ' + tokenResponse.accessToken,
                    'Content-Type': 'application/json',
                    'cid': companyId,
                    // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                  },
                }
              )
              .then(
                (response) => {
                  //console.log(response.data.id);
                  console.log(response);
                  setIsLoadingSubmitPackage(false);
                  // setIsLoadingGetNewData(false);
  
                  getPackage()
    
                  setGetNewData(true);
    
                  setShowSuccess(true);
                  // window.scrollTo(0, 0);
    
                },
                (error) => {
    
                  console.log(error);
                  setIsLoadingSubmitBillingType(false);
                  // setIsLoadingGetNewData(false);
    
                  setGetNewData(true);
    
                  setShowError(true);
                  // window.scrollTo(0, 0);
    
                }
              );
    
          })
          .catch((error) => {
    
            //Acquire token silent failure, and send an interactive request
            console.log(error);
            instance.acquireTokenRedirect(silentRequest);
    
          });
      } else {
        instance
          .acquireTokenSilent({ ...silentRequest, account: account })
          .then((tokenResponse) => {
            axios
              .post(
                `${ADMIN_API_URL}/packages/main`,
                // `http://localhost:7071/api/packages/main`,
                {
                  packageId: selectedMainPackage,
                  from: moment(packageFrom).tz("Asia/Bangkok").startOf('day').toISOString()
                },
                {
                  headers: {
                    Authorization: 'Bearer ' + tokenResponse.accessToken,
                    'Content-Type': 'application/json',
                    'cid': companyId,
                    // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                  },
                }
              )
              .then(
                (response) => {
                  //console.log(response.data.id);
                  console.log(response);
                  setIsLoadingSubmitPackage(false);
                  // setIsLoadingGetNewData(false);
  
                  getPackage()
    
                  setGetNewData(true);
    
                  setShowSuccess(true);
                  // window.scrollTo(0, 0);
    
                },
                (error) => {
    
                  console.log(error);
                  setIsLoadingSubmitBillingType(false);
                  // setIsLoadingGetNewData(false);
    
                  setGetNewData(true);
    
                  setShowError(true);
                  // window.scrollTo(0, 0);
    
                }
              );
    
          })
          .catch((error) => {
    
            //Acquire token silent failure, and send an interactive request
            console.log(error);
            instance.acquireTokenRedirect(silentRequest);
    
          });
      }
    }
  }

  const handleSubmitPackageAddOn = (e) => {
    e.preventDefault();

    if (selectedAddOnPackage && packageAddOnFrom) {
      setIsLoadingSubmitPackageAddOn(true);
      setIsLoadingGetNewData(true);
  
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          axios
            .post(
              `${ADMIN_API_URL}/packages/add-ons`,
              // `http://localhost:7071/api/packages/add-ons`,
              {
                packageId: selectedAddOnPackage,
                from: moment(packageAddOnFrom).tz("Asia/Bangkok").startOf('day').toISOString()
              },
              {
                headers: {
                  Authorization: 'Bearer ' + tokenResponse.accessToken,
                  'Content-Type': 'application/json',
                  'cid': companyId,
                  // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                },
              }
            )
            .then(
              (response) => {
                //console.log(response.data.id);
                console.log(response);
                setIsLoadingSubmitPackageAddOn(false);
                // setIsLoadingGetNewData(false);

                getCurrentPackageAddOn()
  
                setGetNewData(true);
  
                setShowSuccess(true);
                // window.scrollTo(0, 0);
  
              },
              (error) => {
  
                console.log(error);
                setIsLoadingSubmitBillingType(false);
                // setIsLoadingGetNewData(false);
  
                setGetNewData(true);
  
                setShowError(true);
                // window.scrollTo(0, 0);
  
              }
            );
  
        })
        .catch((error) => {
  
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
  
        });
    }
  }

  const handleSubmitNextPackage = (e) => {

    e.preventDefault();

    if (nextPackage) {
      setIsLoadingSubmitNextPackage(true);
      setIsLoadingGetNewData(true);
  
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          axios
            .patch(
              `${ADMIN_API_URL}/packages/main`,
              // `http://localhost:7071/api/packages/main`,
              {
                replace: '/next-period',
                value: {
                  packageId: nextPackage,
                  from: nextPackageFrom ? moment(nextPackageFrom).tz("Asia/Bangkok").startOf('day').toISOString() : ""
                },
                
              },
              {
                headers: {
                  Authorization: 'Bearer ' + tokenResponse.accessToken,
                  'Content-Type': 'application/json',
                  'cid': companyId,
                  // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                },
              }
            )
            .then(
              (response) => {
                //console.log(response.data.id);
                console.log(response);
                setIsLoadingSubmitNextPackage(false);
                // setIsLoadingGetNewData(false);

                getPackage()
  
                setGetNewData(true);
  
                setShowSuccess(true);
                // window.scrollTo(0, 0);
  
              },
              (error) => {
  
                console.log(error);
                setIsLoadingSubmitBillingType(false);
                // setIsLoadingGetNewData(false);
  
                setGetNewData(true);
  
                setShowError(true);
                // window.scrollTo(0, 0);
  
              }
            );
  
        })
        .catch((error) => {
  
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
  
        });
    }
  }

  const handleSubmitPackageTo = (e) => {

    e.preventDefault();

    if (packageTo) {
      setIsLoadingSubmitPackageTo(true);
      setIsLoadingGetNewData(true);
  
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          axios
            .patch(
              `${ADMIN_API_URL}/packages/main`,
              // `http://localhost:7071/api/packages/main`,
              {
                replace: '/to',
                value: moment(packageTo).tz("Asia/Bangkok").startOf('day').toISOString()
              },
              {
                headers: {
                  Authorization: 'Bearer ' + tokenResponse.accessToken,
                  'Content-Type': 'application/json',
                  'cid': companyId,
                  // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                },
              }
            )
            .then(
              (response) => {
                //console.log(response.data.id);
                console.log(response);
                setIsLoadingSubmitPackageTo(false);
                // setIsLoadingGetNewData(false);

                getPackage();
  
                setGetNewData(true);
  
                setShowSuccess(true);
                // window.scrollTo(0, 0);
  
              },
              (error) => {
  
                console.log(error);
                setIsLoadingSubmitBillingType(false);
                // setIsLoadingGetNewData(false);
  
                setGetNewData(true);
  
                setShowError(true);
                // window.scrollTo(0, 0);
  
              }
            );
  
        })
        .catch((error) => {
  
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
  
        });
    }
  }

  const handleSubmitEnabled = (e) => {

    e.preventDefault();

    setIsLoadingSubmitEnabled(true);
    setIsLoadingGetNewData(true);

    let _enabled = (enabled === 'true');

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .patch(
            ADMIN_API_URL + '/companies-details/' + companyId,
            {
              replace: '/enabled',
              value: _enabled
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          )
          .then(
            (response) => {
              //console.log(response.data.id);
              console.log(response);
              setIsLoadingSubmitEnabled(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowSuccess(true);
              // window.scrollTo(0, 0);

            },
            (error) => {

              console.log(error);
              setIsLoadingSubmitEnabled(false);
              // setIsLoadingGetNewData(false);

              setGetNewData(true);

              setShowError(true);
              // window.scrollTo(0, 0);

            }
          );

      })
      .catch((error) => {

        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);

      });

  }

  return (
    <>
      <div style={homeStyles}>

        {showSuccess && (
          <MessageBar
            messageBarType={MessageBarType.success}
            isMultiline={false}
            onDismiss={() => setShowSuccess(false)}
            dismissButtonAriaLabel="Close"
            style={{
              fontSize: 14,
            }}
          >
            บันทึกสำเร็จ!
          </MessageBar>
        )}
        {showError && (
          <MessageBar
            messageBarType={MessageBarType.error}
            isMultiline={false}
            onDismiss={() => setShowError(false)}
            dismissButtonAriaLabel="Close"
            style={{
              fontSize: 14,
            }}

          >
            บันทึกไม่สำเร็จ!
          </MessageBar>
        )}


        <Stack horizontal horizontalAlign="center">
          <Stack
            vertical
            style={{
              width: '80%',
              maxWidth: '500px',
            }}>
            <h1 style={{ marginLeft: '0px', marginTop: '27px' }} ><Icon iconName="CityNext2" style={{ color: '#106ebe' }} /> ตั้งค่าบริษัท</h1>
            {/* <h3 style={{ marginTop: '0px', marginBottom: '10px' }} >{data.companyName}</h3> */}
            {/* <br/> */}
            companyId: {data.companyId}
            <br />
            ชื่อบริษัท: {data.companyName}
            <br />
            อีเมล: {data.email}
            <br />
            <br />

            oid: {data.oid}
            <br />
            อีเมลเข้าสู่ระบบ: {accountData.profiles?.email}
            <br />
            ชื่อ: {accountData.profiles?.firstName} {accountData.profiles?.lastName}
            <br />
            เบอร์โทร: {accountData.profiles?.mobile}
            <br />
            <br />
            {/*                 เครดิตเอกสาร: {credits}
                <br/>
                เติมล่าสุด: {lastTopup}
                <br/>
                เวลาเติมล่าสุด: {lastTopupTime}                                
                <br/>
                <br/>
 */}
            {!isLoadingGetNewData && (
              <div style={cardStyle}>
                <Stack >
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>

                    <DefaultButton
                      iconProps={{ iconName: "Refresh" }}
                      style={{ marginTop: "5px", marginBottom: "5px" }}
                      disabled={isLoadingGetNewData}
                      onClick={() => {
                        setGetNewData(true);
                        setIsLoadingGetNewData(true);
                      }}
                      text="รีเฟรช" />

                  </Stack>

                  <Separator />

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="สถานะบัญชี:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={enabledList}
                      selectedKey={enabled}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setEnabled(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitEnabled &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitEnabled}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitEnabled &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>

                  <br />

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="Billings Type:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={billingsTypeList}
                      selectedKey={billingsType}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setBillingType(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitBillingType &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitฺBillingType}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitBillingType &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>

                  <Separator />
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="ต่ออายุอัตโนมัติ:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={[
                        { key: 'true', text: 'ต่ออัตโนมัติ' },
                        { key: 'false', text: 'ไม่ต่ออัตโนมัติ' },
                        { key: '-', text: '-' },
                      ]}
                      selectedKey={selectedBillingSubscription}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setSelectedBillingSubscription(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitBillingSubscription &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitBillingSubscription}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitBillingSubscription &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>
                  <Separator />
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="การสร้างใบแจ้งค่าบริการด้วยเจ้าหน้าที่:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={[
                        { key: 'true', text: 'เปิด' },
                        { key: 'false', text: 'ปิด' },
                        { key: '-', text: '-' },
                      ]}
                      selectedKey={selectedBillingManual}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setSelectedBillingManual(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitBillingManual &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitBillingManual}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitBillingManual &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>
                  <Separator />
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>

                    <Dropdown
                      label="สร้างใบเสร็จรับเงิน/ใบกำกับภาษีอัตโนมัติ:"
                      styles={dropdownStyles}
                      options={[
                        { key: 'true', text: 'เปิด' },
                        { key: 'false', text: 'ปิด' },
                        { key: '-', text: '-' },
                      ]}
                      selectedKey={selectedAutoCreateReceipt}
                      onChange={(e, selectedOption) => {
                        setSelectedAutoCreateReceipt(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitAutoCreateReceipt &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitAutoCreateReceipt}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitAutoCreateReceipt &&
                      <Spinner styles={spinnerStyles} />
                    }
                  </Stack>
                  <Separator />
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="อัตราภาษีหัก ณ ที่จ่าย:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={[
                        { key: 0, text: '-' },
                        { key: 1, text: '1' },
                        { key: 3, text: '3' },
                      ]}
                      selectedKey={selectPercentWht}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setSelectPercentWht(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitPercentWht &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitPercentWht}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitPercentWht &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>
                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>แพ็กเกจหลัก</strong>
                    </Stack>
                    {currentMainPackage ? (
                      <Stack>
                        <label>สถานะ: {currentMainPackage?.status}</label>
                        <br />
                        <label>{currentMainPackage?.descriptionTH}</label>
                        <label>วันที่ {onFormatDate(new Date(currentMainPackage?.from), "BE")} - {onFormatDate(new Date(currentMainPackage?.to), "BE")}</label>
                      </Stack>
                    ) : (
                      <Stack>
                        <label>-</label>
                      </Stack>
                    )}
                    

                    <Stack style={{ marginTop: "10px" }}>
                      <strong>
                        แพ็กเกจหลักรอบบิลถัดไป

                      </strong>
                    </Stack>
                    {currentMainPackage ? (
                      <Stack>
                        <label>{currentMainPackage?.nextPeriod?.descriptionTH}</label>
                        <label>วันที่ {onFormatDate(new Date(currentMainPackage?.nextPeriod?.from), "BE")} - {onFormatDate(new Date(currentMainPackage?.nextPeriod?.to), "BE")}</label>
                      </Stack>
                    ) : (
                      <Stack>
                        <label>-</label>
                      </Stack>
                    )}

                    {currentMainPackage ? (
                      <Stack style={{ marginTop: "10px" }}>
                        <label><strong>จำนวนรอบบิลที่เหลือ</strong>: {monthsRemaining}</label>
                      </Stack>
                    ) : (
                      <Stack>
                        <label>-</label>
                      </Stack>
                    )}
                    
                  </Stack>
                  <Separator />
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                    <Dropdown
                      // placeholder="Select an option"
                      label="สถานะแพ็กเกจ:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={[
                        { key: '-', text: '-' },
                        { key: 'active', text: 'Active' },
                        { key: 'overdue', text: 'Overdue' },
                        { key: 'expired', text: 'Expired' },
                      ]}
                      selectedKey={selectedPackageStatus}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setSelectedPackageStatus(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitPackageStatus &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitPackageStatus}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitPackageStatus &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>
                  <Separator />
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                    <Dropdown
                      // placeholder="Select an option"
                      label="แพ็กเกจ:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={packages}
                      selectedKey={selectedMainPackage}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setSelectedMainPackage(selectedOption.key);
                      }}
                    />

                    
                    {isLoadingSubmitPackage &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                    <DatePicker
                      name="date"
                      label="วันที่เริ่ม"
                      placeholder="กรุณาเลือก"
                      allowTextInput={false}
                      className={controlClass.control}
                      firstDayOfWeek={firstDayOfWeek}
                      strings={DayPickerStrings}
                      formatDate={onFormatDate}
                      styles={{ root: { width: 150 } }}
                      onSelectDate={(date) => {
                        setPackageFrom(date);
                      }}
                      value={packageFrom}
                    />
                    {!isLoadingSubmitPackage &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitPackage}
                        text="บันทึก" />
                    }
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                    <TextField
                      styles={{ root: { width: 250 }, description: { fontSize: 14}}}
                      label="จำนวนรอบบิลที่เหลือ"
                      onChange={e => {
                        setMonthsRemaining(e.target.value);
                      }}
                      type='number'
                      value={monthsRemaining}
                      description='ระบุตัวเลขเป็น (จำนวนเดือนแพ็กเกจ) - 1 เช่น ถ้าเป็นแพ็กเกจ 2 เดือน ให้ใส่เป็น "1", ถ้าเป็นแพ็กเกจ 6 เดือน ให้ใส่เป็น "5"'
                    />
                    {!isLoadingSubmitMonthsRemainings &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitPackageMonthsRemainings}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitMonthsRemainings &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>

                  <Separator />
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                    <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                      <DatePicker
                        name="date"
                        label="วันที่สิ้นสุดแพ็กเกจ"
                        placeholder="กรุณาเลือก"
                        allowTextInput={false}
                        className={controlClass.control}
                        firstDayOfWeek={firstDayOfWeek}
                        strings={DayPickerStrings}
                        formatDate={onFormatDate}
                        styles={{ root: { width: 150 } }}
                        onSelectDate={(date) => {
                          setPackageTo(date);
                        }}
                        value={packageTo}
                      />
                    </Stack>

                    {!isLoadingSubmitPackageTo &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitPackageTo}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitPackageTo &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>
                  
                  <Separator />
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                    <Dropdown
                      // placeholder="Select an option"
                      label="แพ็กเกจรอบบิลถัดไป:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={packages}
                      selectedKey={nextPackage}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setNextPackage(selectedOption.key);
                      }}
                    />

                    
                    {isLoadingSubmitNextPackage &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                    <DatePicker
                      name="date"
                      label="วันที่เริ่ม"
                      placeholder="กรุณาเลือก"
                      allowTextInput={false}
                      className={controlClass.control}
                      firstDayOfWeek={firstDayOfWeek}
                      strings={DayPickerStrings}
                      formatDate={onFormatDate}
                      styles={{ root: { width: 150 } }}
                      onSelectDate={(date) => {
                        setNextPackageFrom(date);
                      }}
                      value={nextPackageFrom}
                    />
                    {!isLoadingSubmitNextPackage &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitNextPackage}
                        text="บันทึก" />
                    }
                  </Stack>
                  <Separator />

                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>
                        แพ็กเกจเสริมที่มี

                      </strong>

                    </Stack>

                    {currentAddOnPackages.map(_addOnPackage => (
                      <Stack key={_addOnPackage.id} style={{ marginTop: "10px" }}>
                        <label>{_addOnPackage.name}</label>
                        <label>วันที่ {onFormatDate(new Date(_addOnPackage.from), "BE")} - {onFormatDate(new Date(_addOnPackage.to), "BE")}</label>

                      </Stack>
                    ))}
                  </Stack>
                  <Separator />
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                    <Dropdown
                      // placeholder="Select an option"
                      label="แพ็กเกจเสริม:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={packagesAddOns}
                      selectedKey={selectedAddOnPackage}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setSelectedAddOnPackage(selectedOption.key);
                      }}
                    />

                    
                    {isLoadingSubmitPackageAddOn &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                    <DatePicker
                      name="date"
                      label="วันที่เริ่ม"
                      placeholder="กรุณาเลือก"
                      allowTextInput={false}
                      className={controlClass.control}
                      firstDayOfWeek={firstDayOfWeek}
                      strings={DayPickerStrings}
                      formatDate={onFormatDate}
                      styles={{ root: { width: 150 } }}
                      onSelectDate={(date) => {
                        setPackageAddOnFrom(date);
                      }}
                      value={packageAddOnFrom}
                    />
                    {!isLoadingSubmitPackageAddOn &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitPackageAddOn}
                        text="เพิ่ม" />
                    }
                  </Stack>
                  <Separator />
                  {/* <br /> */}

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="ประเภทเอกสาร:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={digitalSignList}
                      selectedKey={digitalSign}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setDigitalSign(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitDigitalSign &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitDigitalSign}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitDigitalSign &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>

                  <Separator />
                  {/* <br /> */}

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="การสร้างไฟล์ PDF:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={pdfaList}
                      selectedKey={pdfa}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setPdfa(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitPdfa &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitPdfa}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitPdfa &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>

                  <br />

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="การแนบไฟล์ XML ในไฟล์ PDF:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={attachXmlList}
                      selectedKey={attachXml}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setAttachXml(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitAttachXml &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitAttachXml}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitAttachXml &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>

                  <br />

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="LTV ในไฟล์ PDF:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={ltvList}
                      selectedKey={ltv}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setLtv(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitLtv &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitLtv}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitLtv &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>

                  <Separator />

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="การแสดงข้อความ Digitally signed by:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={digitallySignedByList}
                      selectedKey={digitallySignedBy}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setDigitallySignedBy(selectedOption.key);
                      }}
                    />

                    {!isLoadingDigitallySignedBy &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleDigitallySignedBy}
                        text="บันทึก" />
                    }
                    {isLoadingDigitallySignedBy &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>

                  <br />

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="รูปแบบปี Digitally signed by:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={digitallySignedByBEList}
                      selectedKey={digitallySignedByBE}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setDigitallySignedByBE(selectedOption.key);
                      }}
                    />

                    {!isLoadingDigitallySignedByBE &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleDigitallySignedByBE}
                        text="บันทึก" />
                    }
                    {isLoadingDigitallySignedByBE &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>

                  <Separator />

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="การส่งข้อความ SMS:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={enableSmsList}
                      selectedKey={enableSms}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setEnableSms(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitEnableSms &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitEnableSms}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitEnableSms &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  </Stack>

                  <Separator />

                  {/* <br /> */}

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>

                    <Dropdown
                      // placeholder="Select an option"
                      label="Service Provider สำหรับส่งไฟล์ XML:"
                      // style={{ width: "150px" }}
                      styles={dropdownStyles}
                      options={serviceProviderList}
                      selectedKey={serviceProvider}
                      // styles={dropdownStyles}
                      onChange={(e, selectedOption) => {
                        console.log(selectedOption);
                        setServiceProvider(selectedOption.key);
                      }}
                    />

                    {!isLoadingSubmitServiceProvider &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitServiceProvider}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitServiceProvider &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                    
                  </Stack>
                  {serviceProvider === "ginkgo-soft" && 
                    <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px" }}>
                      <TextField
                        styles={{ root: { width: 250 }}}
                        required
                        label="API Key:"
                        type={ginkgoShowPassword ? "text" : "password"}
                        onChange={e => {
                          setGinkgoApiKey(e.target.value);
                          setGinkgoRequiredError(false)
                        }} 
                        value={ginkgoApiKey}
                        errorMessage={ginkgoRequiredError ? "กรุณาระบุ" : ""}
                      />
                      <DefaultButton
                        style={{ marginTop: "28px" }}
                        onClick={() => setGinkgoShowPassword(!ginkgoShowPassword)}
                        text={ginkgoShowPassword ? "ไม่แสดง" : "แสดง"}
                      />
                    </Stack>
                  }
                  


                </Stack>
              </div>
            )}
            <br />
            <br />
            <br />

          </Stack>
        </Stack>


        {isLoadingGetNewData && (
          <Stack>
            <br />
            <br />
            <br />
            <Stack horizontal horizontalAlign="center">
              <div className="certificates-loading-center">
                <Spinner
                  label="กำลังโหลด..."
                  labelPosition="down"
                  styles={spinnerStylesLoading}
                />
              </div>
              <br />
            </Stack>
          </Stack>
        )}
      </div>
    </>
  );

}

export default SettingsCompaniesDetails;